import { useState } from 'react';
import styled from 'styled-components';

import { HeaderTitle } from '../../../healtheraComponents';
import Switch from '../../Shared/Switch';
import { OutlinedButton } from '../../Shared/Button';

import CitySearch from './CitySearch';

const fields = {
  country: 'Country',
  county: 'County',
  region: 'Region',
  city: 'City'
};

export default function PharmacyDirectory({ pharmacy, onChange }) {
  const listOnDirectoryEnabled = Boolean(pharmacy.list_on_directory);

  const [editAddressMode, setEditAddressMode] = useState(false);

  function toggleListOnDirectory(_, checked) {
    onChange('list_on_directory', checked);
  }

  function handleSelectCity(cityId) {
    onChange('city_id', cityId);
    setEditAddressMode(false);
  }

  return (
    <>
      <HeaderTitle>Pharmacy directory</HeaderTitle>
      <FieldsContainer>
        {!editAddressMode && (
          <>
            {Object.keys(fields).map(field => (
              <Field key={field}>
                <Label>{fields[field]}</Label>
                <p>{pharmacy.city?.[field] || '-'}</p>
              </Field>
            ))}
            <Field>
              <OutlinedButton onClick={() => setEditAddressMode(true)}>Edit address</OutlinedButton>
            </Field>
          </>
        )}
        {editAddressMode && <CitySearch onSelectCity={handleSelectCity} />}
      </FieldsContainer>
      <Switch
        label="List on directory"
        onChange={toggleListOnDirectory}
        checked={listOnDirectoryEnabled}
        value={listOnDirectoryEnabled}
      />
    </>
  );
}

const FieldsContainer = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  padding: '10px 0'
}));

const Field = styled.div(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '20px',

  '& > p': {
    flex: 1,
    margin: 0,
    padding: 0
  }
}));

const Label = styled.label(() => ({
  fontWeight: '600',
  width: '130px',

  '&:after': {
    content: '":"'
  }
}));
